import { render } from "./CustomDropdown.vue?vue&type=template&id=5d23b4dd&ts=true"
import script from "./CustomDropdown.vue?vue&type=script&lang=ts"
export * from "./CustomDropdown.vue?vue&type=script&lang=ts"

import "./CustomDropdown.vue?vue&type=style&index=0&id=5d23b4dd&lang=css"

import exportComponent from "D:\\ventla-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__